export const testIds = {
  menuItem: 'menu-item',
  childrenWrapper: 'children-wrapper',
  itemLabel: 'item-label',
  scrollPageToTheLeft: 'scroll-page-to-the-left',
  scrollPageToTheRight: 'scroll-page-to-the-right',
};
